export default __webpack_public_path__ + "static/media/iconSecondStep.32d0fb75.svg";